/**
 * ============================================================================
 * RK STICKY ADD TO CART JAVASCRIPT
 * Sticky Bar Interactions & Sync
 * ============================================================================
 *
 * Powered by René Kress - Crovio
 * www.crovio.de
 *
 * © 2025 All Rights Reserved
 * ============================================================================
 */

(function() {
  'use strict';
  
  const stickyBar = document.getElementById('rk-sticky-atc');
  if (!stickyBar) return;
  
  // Get Product JSON
  const productJson = document.getElementById('rk-satc-product');
  const product = productJson ? JSON.parse(productJson.textContent) : null;
  
  // Elements
  const variantIdInput = document.getElementById('rk-satc-variant-id');
  const priceEl = document.getElementById('rk-satc-price');
  const addToCartBtn = document.getElementById('rk-satc-button');
  const qtyInput = document.getElementById('rk-satc-qty-input');
  const qtyMinus = document.getElementById('rk-satc-qty-minus');
  const qtyPlus = document.getElementById('rk-satc-qty-plus');
  const form = document.getElementById('rk-satc-form');
  const showVariantsBtn = document.getElementById('rk-satc-show-variants');
  const modal = document.getElementById('rk-satc-modal');
  const modalPrice = document.getElementById('rk-satc-modal-price');
  const modalConfirm = document.getElementById('rk-satc-modal-confirm');
  const selectedText = document.getElementById('rk-satc-selected-text');
  
  // Current selections
  let currentOptions = {};
  
  // Initialize
  //
  // Achtung: Im Produkt-JSON ist `options` ein Array von Namen (Strings),
  // nicht von Objekten mit `values`. Der frühere Zugriff auf option.values[0]
  // warf deshalb bei jedem Produkt einen Fehler — und weil das noch vor dem
  // Scroll-Listener passierte, erschien die Leiste überhaupt nie. Die Werte
  // holen wir uns stattdessen aus den Varianten.
  if (product && Array.isArray(product.options)) {
    product.options.forEach((option, index) => {
      const schluessel = `option${index + 1}`;
      let wert = null;

      if (option && Array.isArray(option.values)) {
        wert = option.values[0];                       // falls doch Objekte kommen
      } else if (Array.isArray(product.variants)) {
        const vorhanden = product.variants
          .map(v => v[schluessel])
          .filter(v => v !== null && v !== undefined);
        wert = vorhanden[0];
      }

      if (wert !== null && wert !== undefined) currentOptions[schluessel] = wert;
    });
  }
  
  // ==========================================
  // SCROLL DETECTION
  // ==========================================
  
  const triggerOffset = parseInt(stickyBar.dataset.triggerOffset) || 400;
  let lastScroll = 0;
  
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > triggerOffset) {
      stickyBar.classList.add('rk-sticky-atc--visible');
    } else {
      stickyBar.classList.remove('rk-sticky-atc--visible');
    }
    
    lastScroll = currentScroll;
  });
  
  // ==========================================
  // SYNC WITH PRODUCT HERO
  // ==========================================
  
  // Listen for variant changes from Product Hero
  document.addEventListener('productVariantChanged', function(e) {
    if (e.detail && e.detail.variant) {
      updateVariant(e.detail.variant);
    }
  });
  
  // ==========================================
  // VARIANT SELECTION (Inline Buttons)
  // ==========================================
  
  const variantButtons = stickyBar.querySelectorAll('.rk-sticky-atc__variant-btn');
  variantButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const optionPosition = this.dataset.option;
      const optionValue = this.dataset.value;
      
      // Update UI
      variantButtons.forEach(b => {
        if (b.dataset.option === optionPosition) {
          b.classList.remove('rk-sticky-atc__variant-btn--active');
        }
      });
      this.classList.add('rk-sticky-atc__variant-btn--active');
      
      // Update current options
      currentOptions[`option${optionPosition}`] = optionValue;
      
      // Find matching variant
      findAndUpdateVariant();
    });
  });
  
  // ==========================================
  // VARIANT MODAL
  // ==========================================
  
  if (showVariantsBtn && modal) {
    const modalOverlay = modal.querySelector('.rk-sticky-atc-modal__overlay');
    const modalClose = modal.querySelector('.rk-sticky-atc-modal__close');
    const modalValues = modal.querySelectorAll('.rk-sticky-atc-modal__value');
    
    function openModal() {
      modal.classList.add('rk-sticky-atc-modal--active');
      document.body.style.overflow = 'hidden';
    }
    
    function closeModal() {
      modal.classList.remove('rk-sticky-atc-modal--active');
      document.body.style.overflow = '';
    }
    
    showVariantsBtn.addEventListener('click', openModal);
    modalOverlay?.addEventListener('click', closeModal);
    modalClose?.addEventListener('click', closeModal);
    
    // Modal variant selection
    modalValues.forEach(btn => {
      btn.addEventListener('click', function() {
        const optionPosition = this.dataset.option;
        const optionValue = this.dataset.value;
        
        // Update UI
        const optionGroup = this.closest('.rk-sticky-atc-modal__option');
        optionGroup.querySelectorAll('.rk-sticky-atc-modal__value').forEach(b => {
          b.classList.remove('rk-sticky-atc-modal__value--active');
        });
        this.classList.add('rk-sticky-atc-modal__value--active');
        
        // Update current options
        currentOptions[`option${optionPosition}`] = optionValue;
        
        // Find matching variant and update modal price
        findAndUpdateVariant(true);
      });
    });
    
    // Confirm selection
    modalConfirm?.addEventListener('click', function() {
      // Update selected text
      const variant = getCurrentVariant();
      if (variant && selectedText) {
        selectedText.textContent = variant.title;
      }
      closeModal();
    });
  }
  
  // ==========================================
  // VARIANT MATCHING
  // ==========================================
  
  // Vergleicht nur die Optionen, die das Produkt wirklich hat.
  //
  // Vorher wurden immer alle drei stur verglichen. Bei einem Produkt mit
  // einer einzigen Option stehen option2 und option3 der Varianten auf null,
  // die Auswahl kennt sie gar nicht (undefined) — und null === undefined ist
  // falsch. Die Suche fand deshalb nie eine Variante: Wer in der Leiste eine
  // andere Farbe wählte, bekam weiter die erste.
  function passtZurAuswahl(v) {
    const anzahl = Array.isArray(product.options) ? product.options.length : 3;
    for (let i = 1; i <= anzahl; i++) {
      const gewuenscht = currentOptions['option' + i];
      if (gewuenscht === undefined || gewuenscht === null) continue;
      if (v['option' + i] !== gewuenscht) return false;
    }
    return true;
  }
  
  function findAndUpdateVariant(updateModalPrice = false) {
    if (!product || !product.variants) return;
    
    const variant = product.variants.find(passtZurAuswahl);
    
    if (variant) {
      updateVariant(variant, updateModalPrice);
    }
  }
  
  function getCurrentVariant() {
    if (!product || !product.variants) return null;
    
    return product.variants.find(passtZurAuswahl);
  }
  
  function updateVariant(variant, updateModalPrice = false) {
    // Update variant ID
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }
    
    // Update price
    const priceHTML = getpriceHTML(variant);
    if (priceEl) {
      priceEl.innerHTML = priceHTML;
    }
    if (updateModalPrice && modalPrice) {
      modalPrice.innerHTML = priceHTML;
    }
    
    // Update button
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"/>
            <circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          <span class="rk-sticky-atc__button-text">In den Warenkorb</span>
        `;
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = '<span class="rk-sticky-atc__button-text">Ausverkauft</span>';
      }
    }
  }
  
  function getpriceHTML(variant) {
    let html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html = `
        <span class="rk-sticky-atc__price--sale">${formatMoney(variant.price)}</span>
        <span class="rk-sticky-atc__price--compare">${formatMoney(variant.compare_at_price)}</span>
      `;
    } else {
      html = `<span class="rk-sticky-atc__price--regular">${formatMoney(variant.price)}</span>`;
    }
    return html;
  }
  
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }
  
  // ==========================================
  // QUANTITY CONTROLS
  // ==========================================
  
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      if (currentQty > 1) {
        qtyInput.value = currentQty - 1;
      }
    });
  }
  
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      qtyInput.value = currentQty + 1;
    });
  }
  
  // ==========================================
  // ADD TO CART
  // ==========================================
  
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const button = addToCartBtn;
      const originalHTML = button.innerHTML;
      
      // Disable button
      button.disabled = true;
      button.innerHTML = '<div class="rk-sticky-atc__spinner"></div>';
      
      // In den Warenkorb – über denselben Weg wie der große Kaufknopf
      // (öffnet die Schublade mit neuem Inhalt), sonst wie bisher.
      const anfrage = window.rkInDenKorb
        ? window.rkInDenKorb(formData)
        : fetch('/cart/add.js', { method: 'POST', body: formData }).then(response => response.json());
      anfrage
      .then(data => {
        // Success
        button.classList.add('rk-sticky-atc__button--success');
        button.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          <span class="rk-sticky-atc__button-text">Hinzugefügt!</span>
        `;
        
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cartUpdated'));
        
        // Reset after 2 seconds
        setTimeout(() => {
          button.classList.remove('rk-sticky-atc__button--success');
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        button.innerHTML = originalHTML;
        button.disabled = false;
      });
    });
  }
  
})();